import { useEffect, useState } from "react";
import api, { BACKEND_URL } from "@/lib/api";
import { toast } from "sonner";
import { Calendar, Copy, RefreshCw } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function IcalPanel() {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);

  const feedUrl = user?.ical_token
    ? `${BACKEND_URL}/api/ical/${user.ical_token}.ics`
    : null;

  const generate = async () => {
    setBusy(true);
    try {
      await api.post("/ical/token");
      await refresh();
      toast.success("Calendar feed ready");
    } catch { toast.error("Failed"); }
    finally { setBusy(false); }
  };

  const copy = async () => {
    if (!feedUrl) return;
    try {
      await navigator.clipboard.writeText(feedUrl);
      toast.success("Link copied");
    } catch { toast.error("Copy failed"); }
  };

  return (
    <div data-testid="ical-panel" className="border hairline p-5">
      <div className="flex items-start gap-3">
        <Calendar size={20} className="text-[#FF3B30] mt-1" />
        <div className="flex-1">
          <div className="tick-label">Calendar sync</div>
          <div className="font-display text-xl font-bold mt-0.5">Subscribe from Google or Apple Calendar</div>
          <p className="text-neutral-400 text-sm mt-1">
            All your approved & paid bookings, auto-updating. Paste this URL into your calendar app's "Subscribe" option.
          </p>
          {feedUrl ? (
            <div className="mt-3 flex items-stretch gap-2">
              <input
                data-testid="ical-url"
                readOnly
                value={feedUrl}
                className="flex-1 border hairline px-3 py-2 font-mono text-xs focus:outline-none"
                onFocus={(e) => e.target.select()}
              />
              <button data-testid="ical-copy" onClick={copy} className="btn-outline inline-flex items-center gap-2"><Copy size={12} /> Copy</button>
              <button data-testid="ical-rotate" onClick={generate} disabled={busy} className="btn-outline inline-flex items-center gap-2"><RefreshCw size={12} /> Rotate</button>
            </div>
          ) : (
            <button data-testid="ical-generate" onClick={generate} disabled={busy} className="btn-signal mt-3 disabled:opacity-50">
              {busy ? "..." : "Generate feed URL"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
